import {
  apiAddCustomer,
  apiDeleteCustomer,
  apiGetCustomer,
  apiGetCustomerNotifyStatus,
  apiGetCustomers,
  apiUpdateCustomer,
} from "@lib/api/customer";
import { UseQueriesProps } from "@lib/types/General";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";

export const useCustomerQueries = (props: UseQueriesProps) => {
  const { queryKey, params, id, messages, enabled = true } = props;
  const queryKeys = queryKey || [
    "customer",
    params ? JSON.stringify(params) : id,
  ];
  const queryClient = useQueryClient();

  const customerQuery = useQuery({
    queryFn: () => apiGetCustomer(id),
    queryKey: queryKeys,
    enabled: !!id && !!enabled,
  });

  const customersQuery = useQuery({
    queryFn: () => apiGetCustomers(params),
    queryKey: queryKeys,
    enabled: !!params && !!enabled,
  });

  const customerNotifyStatusQuery = useMutation({
    mutationFn: apiGetCustomerNotifyStatus,
    onSuccess() {
      toast.success(messages["common.appStatus.updated"] as string);
    },
  });

  const addCustomerMutation = useMutation({
    mutationFn: apiAddCustomer,
    mutationKey: ["customer"],
    onSuccess() {
      toast.success(
        (messages["common.createdMessage"] as string).replace(
          "{name}",
          messages["common.customer"] as string,
        ),
      );
      queryClient.invalidateQueries({
        queryKey: ["customer"],
      });
    },
  });

  const updateCustomerMutation = useMutation({
    mutationFn: apiUpdateCustomer,
    mutationKey: ["customer"],
    onSuccess() {
      toast.success(
        (messages["common.updatedMessage"] as string).replace(
          "{name}",
          messages["common.customer"] as string,
        ),
      );
      queryClient.invalidateQueries({
        queryKey: ["customer"],
      });
    },
  });

  const deleteCustomerMutation = useMutation({
    mutationFn: apiDeleteCustomer,
    mutationKey: ["customer"],
    onSuccess() {
      toast.success(
        (messages["common.deletedMessage"] as string).replace(
          "{name}",
          messages["common.customer"] as string,
        ),
      );
      queryClient.invalidateQueries({
        queryKey: ["customer"],
      });
    },
  });

  return {
    customerQuery,
    customersQuery,
    addCustomerMutation,
    updateCustomerMutation,
    deleteCustomerMutation,
    customerNotifyStatusQuery,
  };
};
